module.exports = __webpack_public_path__ + "img/location-en.142f1c81.png";